<!-- 削除ボタンを非活性化 -->
<ng-container *ngIf="isAlreadyOffered() || isRegisteredMail(); else enable_delete_button">
    <!-- 提案管理に送信済みか判定 -->
  <ng-container *ngIf="isAlreadyOffered(); else registered_mail_check">
    <i class="fa fa-disabled fa-trash btn-error-feedback" container="body"></i>
  </ng-container>

  <!-- 案件人材管理から登録されたメールか判定 -->
  <ng-template #registered_mail_check>
    <ng-container *ngIf="isRegisteredMail()">
      <i class="fa fa-disabled fa-trash btn-error-feedback" container="body"></i>
    </ng-container>
  </ng-template>
</ng-container>

<!-- 削除ボタン活性化 -->
<ng-template #enable_delete_button>
  <i class="fa fa-dark fa-trash btn-error-feedback" (click)="errorFeedback()"></i>
</ng-template>
